module.exports = __webpack_public_path__ + "img/netedge-logo.b296f17a.png";